import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import {Institution} from '../interface/institution';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InstitutionService {
  httpOptions:any;
  headers:any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }
  
  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };
  }

  getAllInstitution(url){
      return this.http.get(url,this.httpOptions)
  }

  getInstitutionByID(url,param){
    //return this.http.get(url,this.httpOptions)
    return this.http.post<Institution>(url,param,this.httpOptions)
  }

  postInstitution(url,param){
    return this.http.post<Institution>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }

  updateInstitution(url,param){
    return this.http.put<Institution>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
  
  deleteInstitutionByID(url,param){
    return this.http.put<Institution>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
}